import { render, staticRenderFns } from "./recommendLight.vue?vue&type=template&id=8021924c"
import script from "./recommendLight.vue?vue&type=script&lang=js"
export * from "./recommendLight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports